export default __webpack_public_path__ + "static/media/psu-stidti-bolditalic.79336da9.ttf";